import { useQuery } from "@tanstack/react-query";
import { useWebRouter } from "~utils/next-router/use-web-router";
import { graphierQLNextClient } from "utils";
import { useGetCurrentAccountCache } from "~auth/queries/useGetCurrentAccount";
import {
	GetDatasetAccessMethodQuery,
	GetDatasetAccessMethodQueryVariables,
} from "~dataset-view/types/__generated/gql/graphql";

const query = /* GraphQL */ `
	query GetDatasetAccessMethod($id: ID!) {
		getDatasetAccessMethod(id: $id) {
			type
		}
	}
`;

export const getDatasetAccessMethodQueryKey = (id: string) => [
	"getDatasetAccessMethod",
	id,
];

export const useGetDatasetAccessMethod = (id: string) => {
	const { isLoading: isAccountLoading, data: account } =
		useGetCurrentAccountCache();

	return useQuery({
		enabled: !!id && !isAccountLoading,
		queryKey: getDatasetAccessMethodQueryKey(id),
		queryFn: () =>
			graphierQLNextClient<
				GetDatasetAccessMethodQuery,
				GetDatasetAccessMethodQueryVariables
			>({
				query,
				variables: { id },
				useKey: !account?._currentUserRole,
			}).then((res) => res.getDatasetAccessMethod),
	});
};

export const useGetCurrentDatasetAccessMethod = () => {
	const { _query } = useWebRouter();

	return useGetDatasetAccessMethod(_query.datasetId!);
};
